/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthSubmission } from './PalReauthSubmission';
import {
    PalReauthSubmissionFromJSON,
    PalReauthSubmissionFromJSONTyped,
    PalReauthSubmissionToJSON,
    PalReauthSubmissionToJSONTyped,
} from './PalReauthSubmission';

/**
 * 
 * @export
 * @interface CreatePalReauthSubmission201Response
 */
export interface CreatePalReauthSubmission201Response {
    /**
     * 
     */
    data?: PalReauthSubmission;
}

/**
 * Check if a given object implements the CreatePalReauthSubmission201Response interface.
 */
export function instanceOfCreatePalReauthSubmission201Response(value: object): value is CreatePalReauthSubmission201Response {
    return true;
}

export function CreatePalReauthSubmission201ResponseFromJSON(json: any): CreatePalReauthSubmission201Response {
    return CreatePalReauthSubmission201ResponseFromJSONTyped(json, false);
}

export function CreatePalReauthSubmission201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePalReauthSubmission201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PalReauthSubmissionFromJSON(json['data']),
    };
}

export function CreatePalReauthSubmission201ResponseToJSON(json: any): CreatePalReauthSubmission201Response {
    return CreatePalReauthSubmission201ResponseToJSONTyped(json, false);
}

export function CreatePalReauthSubmission201ResponseToJSONTyped(value?: CreatePalReauthSubmission201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PalReauthSubmissionToJSON(value['data']),
    };
}

